export const smartDocParamType_Dynamic = 'dynamic';
//# sourceMappingURL=types.js.map